<template>
  <div class="backtop">
    <img @click="back" src="@/assets/images/back_bai.png" alt="" />
    <span>{{title}}</span>
    <slot name="rightBtn"></slot>
  </div>
</template>
<script>
export default {
    props:{
        title:{
            type: String,
            default(){
                return '详情'
            }
        }
    },
    data(){
        return {}
    },
    methods:{
        back(){
            this.$router.back()
        }
    }
};
</script>
<style scoped>
.backtop {
  background-color: #e95b2d;
  line-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
  padding-right: 10px;
  position: fixed;
  width: 100%;
  left: 0;
  z-index: 9;
}
.backtop span {
  color: #fff;
}
.backtop img {
  position: absolute;
  left: 10px;
  width: 30px;
  height: 30px;
}
</style>